<script>
  import MultiLineChart from './MultiLineChart.svelte'
</script>

<main>
  <MultiLineChart />
</main>
